import { forwardRef } from "react";
import { SVGFillPath, SVGIconRoot } from "./SVGComponents";
import { IconProps } from "./index";

export const Edit = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <SVGIconRoot viewBox="0 0 24 25" ref={ref} {...props}>
      <SVGFillPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.75 8L14 4.25L4 14.25V18H7.75L17.75 8ZM20.71 5.04C21.1 4.65 21.1 4.02 20.71 3.63L18.37 1.29C17.98 0.899998 17.35 0.899998 16.96 1.29L15 3.25L18.75 7L20.71 5.04Z"
      />
      <SVGFillPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 21H24V25H0V21Z"
      />
    </SVGIconRoot>
  );
});
